module.exports = "https://99designs-start-assets.imgix.net/js/3a951fd6b7d62e476f0c7fb0223bdc54.png";